import React from 'react'
import { useParams } from 'react-router-dom'
import DetailWrapper from '../../sharedcomponents/4layouts/DetailWrapper'
import useDetailEditMode from '../../sharedcomponents/4layouts/useDetailEditMode'
import LeftCard from '../../sharedcomponents/5templates/detailCards/leftCard'
import ListBucketCard from '../../sharedcomponents/5templates/detailCards/listBucketCard'
import useDatazone from './useDatazone'
const DatazoneDetail = ({ createMode }) => {
  const { datazoneId, type, subType } = useParams()
  const { detailEditMode, setDetailEditMode } = useDetailEditMode(createMode)
  const {
    typeIdToDisplayName,
    bulkUpdateDataZonesCallBack,
    useGetOneFatDataZoneQuery,
    fetchAuxiliaryRecords,
    makeInMemoryDatazoneRecord,
    datazoneTypes,
    finalAuxiliaryRecords,
    upsertDataZoneCallback,
    removeDataZone,
    suspendDatazone
  } = useDatazone({ setDetailEditMode, createMode })

  const {
    data: { data: rawDatazoneRecord } = {
      data: {}
    },
    refetch,
    isLoading,
    isSuccess
  } = useGetOneFatDataZoneQuery(
    {
      include: ['counts'],
      id: datazoneId
    },
    { skip: createMode, refetchOnMountOrArgChange: true }
  )
  const primaryDatazoneRecord = createMode
    ? makeInMemoryDatazoneRecord(type, subType)
    : JSON.parse(JSON.stringify(rawDatazoneRecord))
  primaryDatazoneRecord.refetch = refetch

  // console.log(primaryDatazoneRecord)

  return (
    <DetailWrapper
      detailEditMode={detailEditMode}
      setDetailEditMode={setDetailEditMode}
      typeIdToDisplayName={typeIdToDisplayName}
      primaryDetailRecord={primaryDatazoneRecord}
      isLoading={!createMode && (isLoading || !isSuccess)}
      secondaryDataLoaderCallBack={fetchAuxiliaryRecords}
      upsertDetailCallback={upsertDataZoneCallback}
      bulkUpdateCallBack={bulkUpdateDataZonesCallBack}
      finalAuxiliaryRecords={finalAuxiliaryRecords}
    >
      {({ formikProps, activationChangeCallback, deleteEntityCallback }) => {
        return (
          <>
            <div style={{ float: 'left', width: '30%' }}>
              <LeftCard
                formikProps={formikProps}
                editMode={detailEditMode}
                typeIdToDisplayName={typeIdToDisplayName}
                deleteEntityCallback={deleteEntityCallback(removeDataZone)}
                activationChangeCallback={activationChangeCallback(suspendDatazone)}
                listOfTypes={datazoneTypes}
                arrayOfBucketConfig={finalAuxiliaryRecords?.primero}
                shortFormat={false}
              />
            </div>
            <div style={{ float: 'left', width: '29%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.segundo}
              ></ListBucketCard>
            </div>
            <div style={{ float: 'left', width: '35%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.tercero}
              />
            </div>
          </>
        )
      }}
    </DetailWrapper>
  )
}
export default React.memo(DatazoneDetail)
